import { red } from '@material-ui/core/colors'
import { createMuiTheme, responsiveFontSizes } from '@material-ui/core/styles'
import GilroyEot from 'src/fonts/Gilroy-Bold.eot'
import GilroyTtf from 'src/fonts/Gilroy-Bold.ttf'
import GilroyWoff from 'src/fonts/Gilroy-Bold.woff'

const gilroy = {
  fontFamily: 'Gilroy-Bold',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 400,
  src: `
    local('Gilroy Bold'),
    local('Gilroy-Bold'),
    url(${GilroyEot}) format('embedded-opentype'),
    url(${GilroyTtf}) format('ttf'),
    url(${GilroyWoff}) format('woff')
  `,
  // unicodeRange:
  //   'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
}

const fontFamily = [
  '"Source Sans Pro"',
  '-apple-system',
  'BlinkMacSystemFont',
  '"Segoe UI"',
  'Roboto',
  '"Helvetica Neue"',
  'Arial',
  'sans-serif',
  '"Apple Color Emoji"',
  '"Segoe UI Emoji"',
  '"Segoe UI Symbol"',
  "'Gilroy'",
].join(',')

const headerFont = `"Gilroy-Bold",${fontFamily}`
const baseMaxWidth = 'none'
const baseSpacing = 8

// A custom theme for this app
const theme = createMuiTheme({
  maxWidth: baseMaxWidth, //deprecated
  baseMaxWidth,
  baseSpacing,
  palette: {
    primary: {
      main: '#574AF0',
    },
    secondary: {
      main: '#37C870',
      light: '#D3E7B2',
      dark: '#209F57',
    },
    cta: {
      main: '#EA4C3C',
    },
    error: {
      main: red.A400,
    },
    background: {
      default: '#fff',
      gray: '#f8f8f8',
      block: '#33357B',
      hero: '#E4E8FF',
      formBackground: '#f8f8f8',
    },
  },
  typography: {
    fontFamily,

    h1: {
      fontFamily: headerFont,
    },

    h2: {
      fontFamily: headerFont,
      fontSize: '2.8rem',
    },

    h3: {
      fontFamily: headerFont,
    },

    h4: {},

    h5: {
      fontSize: '1.15rem',
    },
    h6: {
      fontSize: '1.35rem',
      color: '#565656',
    },

    subtitle1: {
      fontSize: '1.3rem',
    },

    body2: {},
  },
  overrides: {
    MuiButton: {
      root: {
        textTransform: 'none',
        fontSize: '1rem',
        fontWeight: 'bold',
      },
      text: {
        fontWeight: 'normal !important',
      },
      outlined: {
        fontWeight: 'normal !important',
      },
      containedSecondary: {
        color: 'white',
      },
    },
    MuiCssBaseline: {
      '@global': {
        '@font-face': [gilroy],
      },
    },
    MuiFormLabel: {
      root: {
        lineHeight: '1.43em',
      },
    },
    MuiStepper: {
      root: {
        padding: 0,
      },
    },
  },
})

export default responsiveFontSizes(theme)
